import { render, staticRenderFns } from "./LevelSelector.vue?vue&type=template&id=9c2a4e82&scoped=true"
import script from "./LevelSelector.vue?vue&type=script&lang=js"
export * from "./LevelSelector.vue?vue&type=script&lang=js"
import style0 from "./LevelSelector.vue?vue&type=style&index=0&id=9c2a4e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2a4e82",
  null
  
)

export default component.exports